import swiper from "swiper";
import matchHeight from "../../plugins/jquery.matchHeight.js";

var serviseNav = new swiper(".js-top-spot-slider", {
  direction: "horizontal",
  loop: true,
  speed: 500,
  autoplay: false,
  spaceBetween: 15,
  centeredSlides: true,
  observer: true,
  allowTouchMove: true,
  preloadImages: false,
  autoHeight: true,
  slidesPerView: 3.5,
  lazy: {
    loadPrevNext: true,
    loadPrevNextAmount: 2
  },
  pagination: {
    el: ".swiper-pagination",
    clickable: true
  },
  breakpoints: {
    960: {
      slidesPerView: 2
    },
    414: {
      autoHeight: false,
      slidesPerView: 1
    }
  }
});

if ($(".ua-ie").length) {
  $(".top-spot-description").matchHeight();
  $(".top-spot-list-body-image").matchHeight();
}
